<template>
  <div
    class="search-container"
    :class="{ empty: !loading && searchList.length === 0 }"
  >
    <div
      v-if="!loading && searchList.length === 0"
      style="text-align: center; width: 100%"
    >
      empty
    </div>
    <div class="search-result-container">
      <div class="loading" v-show="loading">
        <i style="margin-right: 15px" class="el-icon-loading"></i
        >{{ searchTextStr }}
      </div>
      <template v-if="!loading">
        <div
          class="search-item"
          @click="searchClick(item)"
          v-for="item in searchList"
          :key="item.id"
        >
          <template v-if="item.type === 'InstagramUser'">
            <div
              class="person-image"
              v-lazy:background-image="item.image"
              :key="item.image"
            ></div>
            <div class="person-main-container">
              <div class="person-main-container">
                <div class="username-container">
                  <div class="username">{{ item.title }}</div>
                  <div class="approve-icon" v-show="item.verify"></div>
                </div>
                <div class="des">{{ item.des }}</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="tag-container">
              <div class="tag-title">#{{ item.title }}</div>
              <div class="tag-des">{{ item.des }}</div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.search-container {
  width: 310px;
  min-height: 296px;
  max-height: 350px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  display: flex;
  flex-direction: column;
  &.empty {
    align-items: center;
    justify-content: center;
    flex-direction: row;
    color: gray;
    font-size: 13px;
  }
  .search-result-container {
    overflow: auto;
    flex: 1;
    height: 100%;

    .loading {
      padding: 5px 15px;
      color: @font-color-gray;

      i {
        font-size: 20px;
      }

      height: 50px;
      display: flex;
      align-items: center;
    }

    .search-item {
      display: flex;
      align-items: center;
      padding: 8px 15px;
      cursor: pointer;

      .tag-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .tag-title {
          font-size: 13px;
          color: #333;
        }

        .tag-des {
          font-size: 11px;
          color: gray;
        }
      }

      &:hover {
        background-color: rgba(230, 43, 85, 0.1);
      }

      .person-image {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        background-size: contain;
      }

      .person-main-container {
        margin-left: 5px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        overflow: hidden;

        .username-container {
          display: flex;
          align-items: center;

          .username {
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .approve-icon {
            background-image: url("../../../../public/images/schedule_posts/tag_people/approve@3x.png");
            width: 12px;
            height: 12px;
            background-size: contain;
            margin-left: 4px;
            position: relative;
          }
        }

        .des {
          font-size: 12px;
          color: @font-color-gray;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
<script>
import _ from "lodash";
import axios from "axios";
import { searchTag, searchPeople } from "../../../service/instagram";
import { showErrorMsg } from "../../../utils/errors";

export default {
  name: "TextAreaTagSearchComponent",
  props: {
    socialNetwork: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      history: [],
      cancel: null, // 取消
      loading: true, // 数据是否Loading
      searchList: [], // 查询之后的结果
      text: "", // 查询的字符串
    };
  },
  computed: {
    searchTextStr() {
      return `Searching for "${this.text.substring(1)}"`;
    },
  },
  methods: {
    input: _.debounce(async function (searchText) {
      // 查看是已经保存在历史记录中
      this.loading = true;
      try {
        this.text = searchText;
        let text = this.text.substring(1);
        const currentResult = this.history.find((h) => h.text === searchText);
        if (currentResult) {
          this.searchList = currentResult.list;
          this.loading = false;
          return;
        }
        if (this.cancel) {
          this.cancel();
          this.cancel = null;
        }
        let CancelToken = axios.CancelToken;
        const cancelToken = new CancelToken((c) => {
          this.cancel = c;
        });
        // 判断查询类型，(@:people #:tag)
        if (this.text[0] === "@") {
          this.searchList = await searchPeople({ q: text, cancelToken });
        } else if (this.text[0] === "#") {
          this.searchList = await searchTag({ q: text, cancelToken });
        }
        // 将查询结果保存在历史记录中
        this.history.push({
          text: searchText,
          list: this.searchList,
        });
        this.cancel = null;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.loading = false;
      }
    }, 500),
    /**
     * 查询条件点击事件
     */
    searchClick(item) {
      this.$emit("select", item);
    },
  },
};
</script>
